import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import HeroTreatments from '../../components/HeroTreatments/HeroTreatments';
import ServiceSectionEnhanced from '../../components/ServiceSectionEnhanced/ServiceSectionEnhanced';
import TreatmentModalities from '../../components/TreatmentModalities/TreatmentModalities';
import ConditionsTreatment from '../../components/ConditionsTreatment/ConditionsTreatment';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg';
import './ServicePageV2.css';

const ServicePageV2 = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Advanced Treatments | Wharton's Jelly MSC, PRP, BMAC & Orthobiologics in Florida</title>
                <meta name="description" content="Florida's most advanced regenerative treatments: Wharton's Jelly Mesenchymal Stem Cells, PRP therapy, BMAC, exosomes, MUSE cells. Orthopedic medicine, neurological recovery, anti-aging wellness, and interventional pain procedures." />
                <meta name="keywords" content="Wharton's Jelly stem cells Florida, MUSE cell therapy, PRP injections Sarasota, BMAC treatment, exosome therapy, orthopedic regenerative medicine, neurological stem cell therapy, interventional pain management" />
                <meta property="og:title" content="Advanced Regenerative Treatments - Wharton's Jelly MSC & Cellular Therapies" />
                <meta property="og:description" content="Cutting-edge cellular therapies including Wharton's Jelly MSC, MUSE cells, PRP, and orthobiologics. Available through Florida's progressive regulatory framework." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/treatments" />
                <link rel="canonical" href="https://ampedtherapeutics.com/treatments" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            
            <HeroTreatments />
            
            <ServiceSectionEnhanced />
            
            <TreatmentModalities />
            
            <ConditionsTreatment />
            
            <CtafromSection hclass={'ctafrom_section'} />
            
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};

export default ServicePageV2;